import Flickity from 'flickity';

export default class CustomerImpact {
  constructor() {
    this.$els = document.querySelectorAll('.js-customer-impact');

    this.$els.forEach(($el) => {
      const $carousel = $el.querySelector('.js-customer-impact-carousel');
      const $prevButtons = $el.querySelectorAll('.js-customer-impact-prev');
      const $nextButtons = $el.querySelectorAll('.js-customer-impact-next');

      const carousel = new Flickity($carousel, {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        imagesLoaded: true,
      });

      $prevButtons.forEach(($prevButton) => {
        $prevButton.addEventListener('click', () => {
          carousel.previous();
        });
      });

      $nextButtons.forEach(($nextButton) => {
        $nextButton.addEventListener('click', () => {
          carousel.next();
        });
      });
    });
  }
}
